module.exports = __webpack_public_path__ + "static/media/up-arrow.cf5de995.svg";